export function getStatusText(payout) {
    return payout.isPaid() ? payout.amount().isNegative() ? 'Withdrawn' : 'Deposited' : 'Failed';
}
export function getStatusSkin(payout) {
    return payout.isPaid() ? 'success' : 'error';
}
